<script>
  import SubmissionWizard from './Wizard'
  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'
  import {clone} from 'lodash'
  import bus from '@utils/bus'

  export default {
    components: {SubmissionWizard},
    props: ['submission'],
    data () {
      return {
        data: {
          activeStep: 'confirmation'
        }
      }
    },
    mounted: function () {
      if (!this.submission) {
        this.$router.push({name: 'submission.home'})
      }
      this.data = this.submission
      this.data.activeStep = 'confirmation'
      bus.$emit('hide-loader')
    },
    methods: {
      onNextStep (nextRoute) {
        let params = {submission: this.data}
        this.$router.push({name: nextRoute, params})
      },
      saveSubmission () {
        bus.$emit('show-loader')
        let data = clone(this.submission)
        if (data.id) {
          data.registration_id = data.id
          delete data.id
        }
        delete data.id
        if (data.knowledge_area) {
          data.knowledge_area_id = data.knowledge_area.id
          delete data.knowledge_area
        }
        delete data.event_paper_type
        data.fields.forEach((item) => {
          delete item.field_id
          delete item.created_at
          delete item.updated_at
        })
        restfulService.post('paper', null, null, data)
          .then(_ => {
            bus.$emit('hide-loader')
            notifyService.success({
              hideLoader: true,
              message: 'Sua submissão foi recebida, foi enviado a você um email de confirmação.'
            })
            this.$router.push({name: 'submission.index'})
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="submission-contents">
        <submission-wizard :active-step="data.activeStep"
                           :main-event="data.main_event"
                           :event="data.event"
                           :paper-type="data.paper_type"/>
        <div class="forms form-registration">
            <div class="confirm-registration">
                <h2>Confirmação</h2>
                <h3>Confirme os dados da sua submissão antes de prosseguir.</h3>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <table class="table-confirmation">
                            <tbody>
                            <tr v-if="data.knowledge_area">
                                <td>
                                    <strong>Área do Conhecimento:</strong> {{data.knowledge_area.full_name}}
                                </td>
                            </tr>
                            <tr v-for="item in data.fields">
                                <td v-if="item.field.type !== 'file'">
                                    <strong>{{item.field.name}}:</strong> {{item.value}}
                                </td>
                                <td v-if="item.field.type === 'file'">
                                    <strong>{{item.field.name}}:</strong> {{item.value.name}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </el-col>
                    <el-col :span="12">
                        <table class="table-confirmation">
                            <tbody>
                            <tr v-for="item in data.authors">
                                <td colspan="2" class="author-line">
                                    <div><strong>Nome:</strong> {{item.first_name}} {{item.last_name}}</div>
                                    <div><strong>E-mail:</strong> {{item.email}}</div>
                                    <div class="author-type" :class="item.type">
                                        <span>{{item.type === 'orientador' ? 'Orientador(a)' : ( item.type === 'co_orientador' ? 'Co-Orientador(a)' : 'Autor(a)')}}</span>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </el-col>
                </el-row>
                <div class="buttons-center buttons">
                    <el-button type="default"
                               size="large"
                               @click="onNextStep('submission.authors')"
                               class="btn-confirm-registration">
                        <i class="fa fa-arrow-left"></i>
                        <span>Voltar</span>
                    </el-button>
                    <el-button type="success"
                               size="large"
                               @click="saveSubmission"
                               class="btn-confirm-registration">
                        <i class="fa fa-check"></i>
                        <span>Confirmar Submissão</span>
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .author-line {
        position: relative;
        padding-right: 130px !important;

        .author-type {
            position: absolute;
            right: 10px;
            top: 0;
            display: flex;
            align-items: center;
            height: 100%;
            &.orientador,
            &.co_orientador {
                span {
                    background-color: rgba(255, 189, 8, 0.17);
                }
            }
            span {
                border: 1px solid #dddddd;
                padding: 5px 15px;
                border-radius: 4px;
                background-color: #e6e6e6;
            }
        }
    }
</style>
